import o from "./design-system.es62.js";
import { resolveComponent as r, openBlock as l, createBlock as a, withCtx as i, renderSlot as c } from "vue";
import p from "./design-system.es128.js";
const s = {
  name: "DsButtonGroup",
  components: {
    Inline: o
  },
  props: {
    /**
     * Horizontal alignment of the items
     */
    alignX: {
      type: String,
      default: "left",
      validator: (t) => ["left", "center", "right"].includes(t)
    }
  }
};
function f(t, u, n, m, d, _) {
  const e = r("Inline");
  return l(), a(e, {
    space: "spacing-100",
    "align-x": n.alignX
  }, {
    default: i(() => [
      c(t.$slots, "default")
    ]),
    _: 3
  }, 8, ["align-x"]);
}
const $ = /* @__PURE__ */ p(s, [["render", f]]);
export {
  $ as default
};
//# sourceMappingURL=design-system.es39.js.map
